import { useEffect } from "react";
import { useMotionValue, useReducedMotion, useSpring } from "framer-motion";

// 3D tilt from cursor position (desktop) and device gyroscope (mobile).
// Returns springed rotateX / rotateY motion values in degrees.
export const useTilt = (maxDeg = 10) => {
  const reduce = useReducedMotion();
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rotateX = useSpring(my, { stiffness: 55, damping: 14, mass: 0.6 });
  const rotateY = useSpring(mx, { stiffness: 55, damping: 14, mass: 0.6 });

  useEffect(() => {
    if (reduce) return undefined;
    const onMouse = (e) => {
      mx.set((e.clientX / window.innerWidth - 0.5) * maxDeg);
      my.set(-(e.clientY / window.innerHeight - 0.5) * maxDeg);
    };
    const onOrient = (e) => {
      if (e.gamma == null || e.beta == null) return;
      const g = Math.max(-1, Math.min(1, e.gamma / 35));
      const b = Math.max(-1, Math.min(1, (e.beta - 40) / 35));
      mx.set(g * maxDeg * 0.9);
      my.set(-b * maxDeg * 0.7);
    };
    window.addEventListener("mousemove", onMouse, { passive: true });
    window.addEventListener("deviceorientation", onOrient, { passive: true });
    return () => {
      window.removeEventListener("mousemove", onMouse);
      window.removeEventListener("deviceorientation", onOrient);
    };
  }, [maxDeg, reduce, mx, my]);

  return { rotateX, rotateY };
};
